import React, { FC } from "react";
import {
  _DeliveryOptionsStatusButtonWrapper,
  _DeliveryOptionsStatusRoot,
} from "./DeliveryOptionsStatus.styled";
import DeliveryOptionsStatusBadge from "./DeliveryOptionsStatusBadge";
import Icon from "../../Foundation/Icon/Icon";

export interface IDeliveryOptionsStatusProps {
  visible?: boolean;
  search?: boolean;
  selectLabel?: string;
  locationLabel?: string;
  timeLabel?: string;
  searchLabel?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const DeliveryOptionsStatus: FC<IDeliveryOptionsStatusProps> = ({
  visible = true,
  search = false,
  selectLabel = "",
  locationLabel = "",
  timeLabel = "",
  searchLabel = "",
  onClick = () => {},
  style,
}: IDeliveryOptionsStatusProps) => {
  const primaryLabel = search ? searchLabel : locationLabel;
  return (
    <_DeliveryOptionsStatusRoot {...{ visible }} style={{ cursor: "pointer" }}>
      <_DeliveryOptionsStatusButtonWrapper
        search={search}
        select={true}
        {...{ onClick }}
        title={selectLabel}
      >
        <span>
          <span>{selectLabel}</span>
          <Icon icon={"caret_down_16"} size={16} />
        </span>
      </_DeliveryOptionsStatusButtonWrapper>
      <_DeliveryOptionsStatusButtonWrapper
        search={search}
        {...{ onClick }}
        title={primaryLabel}
        style={style}
      >
        <span className={"primary-label"}>
          <Icon icon={"pin"} size={16} />
          <span>{primaryLabel}</span>
        </span>
        <span title={timeLabel}>
          {search ? (
            <Icon icon={"search"} size={24} />
          ) : (
            <>
              {" "}
              <Icon type={"font"} icon={"clock"} size={16} />
              <span>{timeLabel}</span>
            </>
          )}
        </span>
      </_DeliveryOptionsStatusButtonWrapper>
      {!search && (
        <DeliveryOptionsStatusBadge
          {...{
            onClick,
            timeLabel,
            modeLabel: selectLabel,
            locationLabel: primaryLabel,
          }}
        />
      )}
    </_DeliveryOptionsStatusRoot>
  );
};

export default DeliveryOptionsStatus;
